import thumbnail from './thumbnail.svg'
import icon from './icon.svg'

export const metadata = {
  id: 'rawgraphs.histogram',
  name: 'Histogram',
  thumbnail,
  icon,
  categories: ['distributions'],
  description:
    'A histogram is an approximate representation of the distribution of numerical data. It was first introduced by Karl Pearson.',
  code: 'https://github.com/rawgraphs/rawgraphs-charts/tree/master/src/histogram',

}
